<template>
  <div class="advice">
    <v-layout v-for="(article) in articles" :key="article.id">
      <v-flex>
        <v-card>
          <v-img
                  :src="article.image_url_full"
                  aspect-ratio="2"
                  class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
          <v-card-title primary-title class="pb-0">
            <div>
              <h3 class="headline mb-0">{{ article.title }}</h3>
              <span class="grey--text time-text">{{ article.date | moment }}</span><br>
              <div class="excerpt"> {{ article.excerpt }} </div>
            </div>
          </v-card-title>

          <v-card-actions class="pt-0 mb-3">
            <v-btn text color="primary" :to="'/advice/' + article.slug">Read More</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>

  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    mounted() {
      //console.log('mounted advice')
      this.$store.commit('articles/SET_ARTICLES', null)
      this.$store.dispatch('articles/loadArticles')
    },
    computed: {
      ...mapState({
        articles: state => state.articles.posts
      }),
    },
    filters: {
      moment: function (date) {
        return moment(date).fromNow();
      }
    }
  }
</script>

<style scoped lang="scss">
    .headline {
        word-break: break-word;
    }
  .advice {
    width: 100%;
  }
  .time-text {
      font-size: .7em;
  }
  .excerpt {
      font-size: .8em;
      line-height: 1.5em;
      font-weight: 400;
  }
</style>
